import React, { useEffect, useState } from 'react';
import { gsap } from 'gsap';

const LoadingScreen = ({ onLoadingComplete }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    // Simulate loading progress
    const interval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(interval);
          // Animate loading bar to 100% then fade out
          gsap.to('.loading-bar', {
            width: '100%',
            duration: 0.5,
            onComplete: () => {
              gsap.to('#loading-screen', {
                opacity: 0,
                duration: 1,
                delay: 0.5,
                onComplete: onLoadingComplete
              });
            }
          });
          return 100;
        }
        return prev + Math.random() * 15;
      });
    }, 100);

    return () => clearInterval(interval);
  }, [onLoadingComplete]);

  useEffect(() => {
    gsap.to('.loading-bar', {
      width: `${progress}%`,
      duration: 0.3
    });
  }, [progress]);

  return (
    <div id="loading-screen">
      <div className="loading-content">
        <h1>JFK<span>PRODUCTIONS</span></h1>
        <div className="loading-bar-container">
          <div className="loading-bar"></div>
        </div>
        <p className="loading-text">Loading Experience</p>
      </div>
    </div>
  );
};

export default LoadingScreen;